/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  CsMasterRestService,
  JobColorSelectionRestService, JobRestService,
} from '@gh/builder-shared-data';
import { AutocompleteItem } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { compact } from 'lodash';

@Injectable()
export class JobCsCreateBusinessService {

  constructor(private jobColorSelectionRest: JobColorSelectionRestService,
              private jobRest: JobRestService,
              private colorSelectionMasterRest: CsMasterRestService) {

  }

  findCsMastersByName(query: FilteredDataQuery<any>): Observable<AutocompleteItem[]> {
    return this.colorSelectionMasterRest.findAllAsFinderDataSource({
      showDeleted: false,
      searchString: query.filter,
    })
      .select(query).pipe(map$(getSlicedData));
  }

  findAllJobs(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.jobRest.findAllAsAutocompleteDataSourceForFinder({
      showDpp: true,
      showActive: true,
      showFinalized: false,
      showNotProceeding: false,
      searchString: query.filter,
      isCsExist: false,
    })
      .select(query).pipe(
        map$(getSlicedData),
        map$((jobs) => jobs.map((job) => ({
          id: job.id,
          name: job.jobNumber,
          description: job.siteAddress,
          display: compact([job.jobNumber, job.contactName, job.siteAddress]).join(' '),
        }))));
  }
}
